import React, { memo, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './Loader.css';

const LOADER_MESSAGES = [
    'Cargando datos...',
    'Procesando información...',
    'Actualizando registros...',
    'Casi listo...',
    'Un momento por favor...'
];

const Loader = ({ fullScreen = false, size = 'default', transparent = false, showText = true }) => {
    const containerClass = fullScreen
        ? "fixed inset-0 flex items-center justify-center z-50"
        : "flex items-center justify-center min-h-[200px]";

    const backgroundClass = transparent
        ? 'bg-transparent'
        : (fullScreen ? 'bg-white dark:bg-gray-900' : 'bg-transparent');

    // Tamaño del logo y spinner
    const logoSize = size === 'small' ? 40 : size === 'large' ? 64 : 48;
    const spinnerSize = logoSize + 16;

    // Mensajes dinámicos
    const [messageIndex, setMessageIndex] = useState(0);
    useEffect(() => {
        if (!showText) return;
        const interval = setInterval(() => {
            setMessageIndex((prev) => (prev + 1) % LOADER_MESSAGES.length);
        }, 2000);
        return () => clearInterval(interval);
    }, [showText]);

    return (
        <div className={`${containerClass} ${backgroundClass}`}>
            <div className="flex flex-col items-center">
                {/* Spinner y Logo */}
                <div className="relative">
                    {/* Spinner */}
                    <motion.div
                        className="absolute inset-0"
                        initial={{ rotate: 0 }}
                        animate={{ rotate: 360 }}
                        transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            ease: "linear"
                        }}
                    >
                        <div
                            className="w-full h-full border-2 border-t-blue-500 dark:border-t-blue-400 border-transparent rounded-full"
                            style={{
                                width: spinnerSize,
                                height: spinnerSize
                            }}
                        />
                    </motion.div>

                    {/* Logo */}
                    <div
                        className="rounded-full bg-white dark:bg-gray-800 flex items-center justify-center shadow-sm"
                        style={{
                            width: logoSize,
                            height: logoSize,
                            margin: (spinnerSize - logoSize) / 2
                        }}
                    >
                        <img
                            src="/assets/images/logoesfera-wonder.webp"
                            alt="Cargando..."
                            className="w-3/4 h-3/4 object-contain"
                        />
                    </div>
                </div>

                {/* Mensaje */}
                {showText && (
                    <motion.div
                        key={messageIndex}
                        initial={{ opacity: 0, y: 5 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -5 }}
                        transition={{ duration: 0.2 }}
                        className="mt-4 text-center"
                    >
                        <p className="text-sm font-medium text-gray-600 dark:text-gray-300">
                            {LOADER_MESSAGES[messageIndex]}
                        </p>
                        {/* Barra de progreso simple */}
                        <div className="mt-2 w-36 h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                            <motion.div
                                className="h-full bg-blue-500 dark:bg-blue-400 rounded-full"
                                initial={{ width: "0%" }}
                                animate={{ width: "100%" }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "linear"
                                }}
                            />
                        </div>
                    </motion.div>
                )}
            </div>
        </div>
    );
};

export default memo(Loader);
